import { cloneDeep } from 'lodash-es'
import { PartitionCategoryType } from '@/apis/datastore/types'
import type { templateRuleFormData } from './constant/base'

type RuleFormData = typeof templateRuleFormData

function replace(obj: any, placeholder: string, target: string) {
  Object.entries(obj).forEach(([k, v]) => {
    if (typeof v === 'string') {
      obj[k] = v.replace(placeholder, target)
    } else {
      replace(v, placeholder, target)
    }
  })
}

export function getRuleFormDataByTemplate(
  template: RuleFormData,
  userName = '',
): RuleFormData {
  const templateData = cloneDeep(template)
  replace(templateData, '{user}', userName)
  return templateData
}

export function getPartitionTypeName(type?: PartitionCategoryType) {
  return type === PartitionCategoryType.QA ? '问答' : '文档'
}
